<template>
  <div class="mapViewer">
    <div class="mapViewer__app">
      <router-view :items="visibleFerries" :searchFilter="filter" :loadingOverview="loadingOverview"
        :showNotificationsDialog="showNotificationsDialog" :selectedFerrySlug="selectedFerrySlug"
        @set-filter="filter = $event" @select-ferry="selectedFerrySlug = $event" @map-command="mapCommand = $event" />
    </div>

    <OpenLayers :mapCommand="mapCommand" :items="filteredFerries" :selectedFerrySlug="selectedFerrySlug"
      @select-ferry="selectedFerrySlug = $event" @map-extent-change="visibleExtent = $event" />
  </div>
</template>

<script>
import OpenLayers from './components/OpenLayers';
import { containsCoordinate } from "ol/extent";
import { fromLonLat } from "ol/proj";

export default {
  name: "app",
  components: { OpenLayers },
  data() {
    return {
      ferries: [],
      filter: "wandelen",
      results: [],
      loadingOverview: true,
      mapCommand: null,
      selectedFerrySlug: null,
      showNotificationsDialog: false,
      visibleExtent: null,
    };
  },
  computed: {
    filteredFerries() {
      return this.ferries.filter((ferry) => {
        return ferry.transports.some((transport) => {
          return transport.slug === this.filter;
        });
      });
    },
    visibleFerries() {
      if (!this.visibleExtent) return this.ferries;

      return this.filteredFerries.filter((ferry) => {
        return ferry.stops.some((stop) => {
          const coords = fromLonLat([stop.lng, stop.lat]);

          return containsCoordinate(this.visibleExtent, coords);
        });
      });
    }
  },
  async mounted() {
    this.getUserLocation();

    await this.fetchData();

    if (this.$route.path.replaceAll("/", "") === "meldingen") {
      this.showNotificationsDialog = true;
    }
  },
  methods: {
    async fetchData() {
      this.loadingOverview = true;

      try {
        const response = await fetch(process.env.API + "/ferries", {
          headers: {
            'Cache-Control': 'no-cache'
          }
        });
        const data = await response.json();

        this.ferries = data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingOverview = false;
      }
    },
    getUserLocation() {
      if (!navigator.geolocation) {
        console.log("Geolocation not supported");

        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.mapCommand = {
            type: "center",
            payload: {
              lng: position.coords.longitude,
              lat: position.coords.latitude,
            }
          };
        },
        (error) => {
          console.log("Location error:", error);
        },
        {
          enableHighAccuracy: true
        }
      );
    }
  },
};
</script>

<style lang="css">
.loadingScreen {
  background-image: url("assets/loading.gif");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 1.8em;
  bottom: 0;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.button {
  background-color: #282a79;
  border-radius: 3px;
  color: #fff;
  display: inline-block;
  font-family: "Roboto Slab", sans-serif;
  font-size: 1em;
  padding: 0.625em 2em;
  min-width: 140px;
  text-align: center;
  transition: box-shadow 0.6s ease-out;
  border: none;
  box-shadow: 0 0 9px #8886b7;
  text-transform: uppercase;
  font-weight: 400;
  text-decoration: none;
}

.button.-fullWidth {
  display: block;
  margin-bottom: 1em;
  width: 100%;
}

.button:hover,
.button:focus {
  box-shadow: 0 0 9px 0 #8886b7;
  color: #fdc700;
  transition: box-shadow 0.3s ease-in-out;
}

.mapViewer__app {
  background-color: white;
  border-top-left-radius: 1em;
  border-top-right-radius: 1em;
  box-shadow: 0 0 0.6em 0 rgba(42, 69, 103, 0.5);
  margin-top: calc(75vh - 100px);
  min-height: 25vh;
  padding: 0 0 1.8em;
  position: relative;
  width: 100%;
  z-index: 20;
}

.mapViewer__map {
  background-color: #eee;
  bottom: 0;
  left: 0;
  position: fixed !important;
  right: 0;
  top: 0;
  z-index: 15;
}

@media screen and (min-width: 39em) {
  .mapViewer {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
  }

  .mapViewer__app {
    border-radius: 0;
    bottom: 0;
    left: 0;
    margin: 0;
    overflow: auto;
    padding-top: 100px;
    padding-bottom: 0;
    position: absolute;
    top: 0;
    width: 40%;
  }

  .mapViewer__map {
    left: 40%;
  }
}

@media screen and (min-width: 54em) {
  .mapViewer__app {
    width: 21em;
  }

  .mapViewer__map {
    left: 21em;
  }
}

.methods {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 1em;
}

.methods__item {
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  display: inline-block;
  height: 0;
  margin-right: 0.5em;
  overflow: hidden;
  padding: 1.5em 0 0 1.2em;
  width: 0;
}

.methods__item.text {
  width: auto;
  height: 1.4em;
  padding: 0;
  font-size: 12px;
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  color: #2a4567;
  opacity: 0.65;
}

.methods__item.auto {
  background-image: url("./assets/icon-car.svg");
  padding-left: 2.4em;
}

.methods__item.fiets {
  background-image: url("./assets/icon-bike.svg");
  padding-left: 2em;
}

.methods__item.wandelen {
  background-image: url("./assets/icon-walk.svg");
  padding-left: 1.5em;
}

.methods__item.pin {
  background-image: url("./assets/icon-pin.svg");
  padding-left: 1.5em;
}

.icon {
  background-position: bottom center;
  background-size: contain;
  background-repeat: no-repeat;
  display: inline-block;
  height: 0;
  margin-right: 0.5em;
  overflow: hidden;
  padding: 1.5em 0 0 1.2em;
  width: 0;
}

.icon.-auto {
  background-image: url("./assets/icon-car.svg");
  padding-left: 2.4em;
}

.icon.-fiets {
  background-image: url("./assets/icon-bike.svg");
  padding-left: 2em;
}

.icon.-wandelen {
  background-image: url("./assets/icon-walk.svg");
  padding-left: 1.5em;
}

.icon.-light.-auto {
  background-image: url("./assets/icon-car-light.svg");
}

.icon.-light.-fiets {
  background-image: url("./assets/icon-bike-light.svg");
}

.icon.-light.-wandelen {
  background-image: url("./assets/icon-walk-light.svg");
}
</style>
